import cx from 'classnames'
import type React from 'react'

import { IconX } from '../../../../icons'
import css from './Action.module.scss'

type Props = {
  can?: 'clear'
  onClear?: () => void
  size?: 'small' | 'medium' | 'large'
  value?: string
}

const Action: React.FC<Props> = ({ can, onClear, size, value }) => {
  if (!can || value === '') {
    return null
  }

  return (
    <div className={cx(css.action, size && css[size])}>
      {can === 'clear' && (
        <div className={css.clear}>
          <button type="button" onClick={onClear}>
            <IconX size={16} />
          </button>
        </div>
      )}
    </div>
  )
}

export default Action
